var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field",class:{
        'is-condensed': _vm.isCondensed,
        'is-sticky': _vm.isSticky
    },attrs:{"sortIndex":(_vm.sortingCount > 1 || _vm.sort !== 'name' || _vm.isSortedReverse) ? _vm.isSorted : 0,"data-align":_vm.align}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }